<template>
  <nav class="navbar navbar-expand-lg fixed-top border-bottom">
    <div class="navigation-content">
      <div class="d-flex align-items-center gap-3">
        <a id="firstTabIndex" tabindex="1" :href="logoHref" @click="onLogoClick" class="cursor-pointer">
          <img id="logo" :class="logoMargin" :src="logoPath" alt="Go to website homepage">
        </a>
        <div v-if="!preparerContext" id="edition" class="d-flex align-items-center">
          <span>{{ appYear }}</span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'
import getAppName from "@/functions/getAppName"
import getAppYear from "@/functions/getAppYear"
import {computed, ref, watch} from "vue";
import {refreshTokens} from '@/functions/authenticatedRequest'
import {isPreparerContext} from "@/functions/getPreparerContext"

const appName = getAppName()
const appYear = getAppYear()
const defaultLogoPath = require('../assets/img/' + appName.toLowerCase() + '_logo.svg')
const preparerLogoPath = require('../assets/img/preparerlogo.svg')
const landingURL = ref()
const route = useRoute()
const useAuthenticatedNavLink = ref(false)
const preparerContext = ref(isPreparerContext())
const logoPath = computed(() => preparerContext.value ? preparerLogoPath : defaultLogoPath)
const preparerURL = `https://${process.env.VUE_APP_PREPARER_SUBDOMAIN}.${appName.toLowerCase()}.com`
const logoHref = computed(() => {
  if (preparerContext.value) return preparerURL
  if (useAuthenticatedNavLink.value) return undefined
  return landingURL.value
})
const onLogoClick = (event) => {
  // Passkey.vue arms a beforeunload guard that prompts unless a navigation marks
  // itself intentional. The href here leaves the document without going through
  // redirectToWelcomePage, which is the only other place that marks it (#413).
  if (preparerContext.value) {
    window.isIntentionalNavigation = true;
    return
  }
  if (useAuthenticatedNavLink.value) {
    event.preventDefault()
    redirectToWelcomePage()
  }
}
const logoMargin = computed(() => {
  if (preparerContext.value) return ''
  return appName === 'Express1040' ? 'mt-1px' : 'mt--2px'
})
let serverType = sessionStorage.getItem('serverType')

if (serverType === 'TEST' || serverType === 'STAGE')
{
  landingURL.value = 'https://' + serverType.toLowerCase() + '.' + appName.toLowerCase() + '.com'
}
else
{
  landingURL.value = 'https://www.' + appName.toLowerCase() + '.com'
}
if  (location.href.includes('FREEFILE') || sessionStorage.getItem('isFreeFile'))
{
  landingURL.value += '/freefile' + process.env.VUE_APP_CURRENT_TAX_YEAR
}

watch(
    () => route.path,
    (newPath) => {
      const accountPages = [
        '/account-info',
        '/account-activity',
        '/edit-email',
        '/edit-mobile-phone',
        '/edit-password',
        '/edit-second-email',
        '/edit-security-settings',
        '/edit-security-settings-password',
        '/edit-username',
        '/enable-auth-app',
        '/enable-auth-app-qr-code',
        '/enable-auth-app-success',
        '/enable-emergency-codes',
        '/enable-text-verification',
        '/passkey',
        '/passkey-upsell',
      ];
      useAuthenticatedNavLink.value = accountPages.includes(newPath);
      preparerContext.value = isPreparerContext();
    },
    { immediate: true }
);

const redirectToWelcomePage = () => {
  refreshTokens().then(() => {
    window.isIntentionalNavigation = true;
    let parameters = {
      'tp': 199,
      'thn': sessionStorage.getItem('thn')
    }
    let redirectUrl = sessionStorage.getItem('redirectUrl')

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = redirectUrl;
    document.body.appendChild(form);

    for (const key in parameters) {
      const formField = document.createElement('input');
      formField.type = 'hidden';
      formField.name = key;
      formField.value = parameters[key];
      form.appendChild(formField);
    }
    form.submit()
  });
}
</script>

<style lang="scss" scoped>
.navbar {
  background-color: $white;
  padding-bottom: 0;
  padding-top: 0;
  height: 3.5rem;

  @include breakpoint(sm) {
    height: 4rem;
  }
}

.navigation-content {
  @include contentWidth(nav);

  max-width: 100%;
  margin: 0 1rem;
  padding: 0;
  position: relative;
  width: 1152px;

  @include breakpoint(sm) {
    margin: 0 16px;
    padding: 0;
    max-width: 100%;
  }

  @include breakpoint(xl) {
    margin: 0 2rem;
  }
}

.navbar-expand-lg .navbar-nav .nav-link {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}

#logo {
	height: 2rem;

	&.mt-1px {
		margin-top: 1px;
	}
	&.mt--2px {
		margin-top: -2px;
	}
}

#edition {
  color: $dark-gray;
  font-size: 1rem;
  font-weight: $font-weight-bolder;
}
</style>
